
export const BUSINESS_CODE = {

    MAX_QUERY_SIZE_EXCEEDED: 'MAX_QUERY_SIZE_EXCEEDED'

}
